import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.ModifierField')
export class ModifierField extends AbstractModel {
  @JsonProperty(String, 'value')
  value?: string

  @JsonProperty(String, 'pricingItemField')
  pricingItemField?: string

  @JsonProperty(String, 'type')
  type?: string
}

